import { types as ActionTypes, asyncEvents as AsyncEvents } from './LitigationDetails.actions';

import { types as AuthActionTypes } from '/b2b/authentication/state/Auth.actions';
import { CRUDDetailsReducers } from '../../common/helpers/ReduxHelpers';
import { combineReducers } from 'redux';
import genericReducer from '../../common/helpers/Redux/genericReducer';
import reduceReducers from 'reduce-reducers';
import schema from './db/UnicourtCase.schema';

export const initialState = {
    id: null,
    loading: false,
    error: null,
};

export default reduceReducers(
    initialState,
    combineReducers({
        ...CRUDDetailsReducers(
            initialState,
            Object.keys(AsyncEvents).map(key => ActionTypes[key]),
            schema
        ),
    }),
    genericReducer(initialState, {
        [AuthActionTypes.logout]: () => initialState,
    })
);
